// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.BranchValidation[data-v-00128031] {\n  line-height: 1.6rem;\n}\n.BranchValidation p[data-v-00128031] {\n  font-size: 1rem !important;\n}\n.buttonAction[data-v-00128031] {\n  width: -moz-fit-content;\n  width: fit-content;\n  min-width: 250px;\n  max-width: 400px;\n  margin: auto;\n}\n.buttonAction span[data-v-00128031] {\n  margin-left: 7px;\n}\n.flexMiddle[data-v-00128031] {\n  display: flex;\n  justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
